// Copyright 2016 Sorama B.V.

import { IOverride } from "overrides/IOverride";

export type IPolyfill = IOverride;

export class Polyfills<T> implements Iterator<T> {
    w3: T;
    webkit: T;
    moz: T;
    ms: T;

    constructor(w3: T, webkit: T, moz: T, ms: T) {
        this.w3 = w3;
        this.webkit = webkit;
        this.moz = moz;
        this.ms = ms;

        this.all = [this.w3, this.webkit, this.moz, this.ms];
    }

    //#region IterableIterator<T> Members
    private all: T[];
    private currentIdx = 0;

    next(): IteratorResult<T> {
        if (this.currentIdx < this.all.length) {
            return <IteratorResult<T>>{ done: false, value: this.all[this.currentIdx++] };
        } else {
            return <IteratorResult<T>>{ done: true };
        }
    }

    [Symbol.iterator](): IterableIterator<T> {
        return this;
    }
    //#endregion
}
